import React from "react";
import GhostDataTableHeader from "./GhostDataTableHeader";
import GhostDataTableBody from "./GhostDataTableBody";

const GhostDataTable = ({
  headers,
  rows = 8,
  title,
  description,
  rightElement, // Can be search bar or button
  showPagination = true,
}) => {
  return (
    <div className="standard-data-table-container">
      {/* 1. Use the Header Ghost */}
      <GhostDataTableHeader
        title={title}
        description={description}
        rightElement={rightElement}
      />

      {/* 2. Use the Body Ghost */}
      <GhostDataTableBody headers={headers} rows={rows} />

      {/* 3. Simple Pagination Mirror */}
      {showPagination && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "200px",
              height: "32px",
              backgroundColor: "#f3f4f6",
              borderRadius: "6px",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default GhostDataTable;
